import { Component, OnInit, Input } from '@angular/core';
import { Helper } from '../../Helper';
import { Router } from '@angular/router';
import { MatBottomSheet, MatDialog } from '@angular/material';
import { BottomSheetOverviewExampleSheet } from '../../tabs/tabs.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-ticket',
  templateUrl: './Tickets.component.html',
  styleUrls: ['./Tickets.component.css','../../sub-admin/subadmin.component.css','../../../assets/bootstrap.css']
})
export class TicketsComponent implements OnInit {

  displayedColumnsOffices: string[] =  ['ticket_id','user', 'subject',"description","date"];

  dataOffices=[

  ];
  maxDate=new Date();
  form = new FormGroup({
    search:new FormControl('', []),
    start_date: new FormControl('', [Validators.required]),
    end_date: new FormControl('', [Validators.required]),


  }
  );
  showView=false;
  viewElement={};
  search=""
  timer=null
  data:any={}
  page=1
  per_page=25;
   _type="open-ticket";
  constructor(public Helper:Helper , public router:Router,
    public dialog:MatDialog,
    private _bottomSheet: MatBottomSheet) { }

    @Input()
    set type(val){
        this._type=val
        this.dataOffices=[]
        this.data=[]
        this.getdata()
    };
  ngOnInit() {

  }
  searchData(e){

    if(this.search=="")  return 1;

    if(this.timer)
      clearTimeout(this.timer);

    this.timer=setTimeout(()=>{
       this.page=1;
       this.getdata()
    },500)

  }
  onBack(){

    this.showView=false;
  }
  searching=true;
  getdata(){
    this.searching=true;

    this.Helper.makeRequest("admin/tickets?page="+this.page+"&search="+this.search+"&type="+this._type+"&start_date="+this.form.value.start_date+"&end_date="+this.form.value.end_date,{},"get",{toast:false}).subscribe(d=>{
      console.log(d.data,"d.data")
      this.dataOffices= d.data.data;
      this.data= d.data;
      this.searching=false;
    })
  }

  downloadExcel(){
    window.open(this.Helper.globalAPiUrl+"admin/tickets?page="+this.page+"&search="+this.search+"&type="+this._type+"&start_date="+this.form.value.start_date+"&end_date="+this.form.value.end_date+"&download=xls&token="+this.Helper.get("token"))
  }
  prev(){
    this.page=this.page-1;
    this.getdata();
  }
  next(){
    this.page=this.page+1;
    this.getdata();
  }
  view(el){
      this.showView=true;
      this.viewElement=el.slug;
  }

  delete(el){
    let sheet=this._bottomSheet.open(BottomSheetOverviewExampleSheet,{ ariaLabel: 'Are you sure you want to delete this experience'});
    sheet.afterDismissed().subscribe((data) => {
      if(data){
        this.Helper.makeRequest("admin/delete-message/"+el.slug,{id:el.slug},"delete").subscribe(d=>{
          this.getdata();

        })
      }

    });
  }


}
